import { useEffect, useState } from 'react';
/*
  This date-state hook is required for SSR pages because w/o it React throws a hydration error due to different server
  and client timezones
*/
export default function useSSRDate(date) {
  const [formattedDate, setDate] = useState(
    new Date(date).toLocaleDateString('en-US', {
      timeZone: 'UTC',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    })
  );

  useEffect(() => {
    setDate(
      new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    );
  }, []);

  return { formattedDate };
}
